<template>
	<div id="app" class="app" v-if="appShow" :style="{'width':width+'px','height':height+'px'}">
		<div v-if="pc" class="pc_container full flex">
			<div class="qrcode">
				<vue-qr :text="qr.url" :size="300" :margin="10"></vue-qr>
			</div>
			<span>微信扫码观看</span>
		</div>
		<div v-if="!pc" class="phone_container full flex">
			<media />
			<transition name="fade">
				<page :containerWidth="width" :containerHeight="height" :direction="direction"
					v-if="currentPage=='load'">
					<load />
				</page>
			</transition>
			<transition name="fade">
				<page :containerWidth="width" :containerHeight="height" :direction="direction" v-if="currentPage=='p1'">
					<p1 @bgm="bgmHandle" />
				</page>
			</transition>
			<transition name="fade">
				<page :containerWidth="width" :containerHeight="height" :direction="direction"
					v-if="currentPage=='game1'">
					<game @bgm="bgmHandle" @flash="game1Key = Math.random()" :key="game1Key" :level="1" />
				</page>
			</transition>
			<transition name="fade">
				<page :containerWidth="width" :containerHeight="height" :direction="direction"
					v-if="currentPage=='game2'">
					<game @bgm="bgmHandle" @flash="game2Key = Math.random()" :key="game2Key" :level="2" />
				</page>
			</transition>
			<transition name="fade">
				<page :containerWidth="width" :containerHeight="height" :direction="direction"
					v-if="currentPage=='game3'">
					<game @bgm="bgmHandle" @flash="game3Key = Math.random()" :key="game3Key" :level="3" />
				</page>
			</transition>
			<transition name="fade">
				<page :containerWidth="width" :key="p2Key" :containerHeight="height" :direction="direction"
					v-if="currentPage=='p2'">
					<p2 @bgm="bgmHandle" @flash="p2Key = Math.random()" />
				</page>
			</transition>
			<transition name="fade">
				<page :containerWidth="width" :containerHeight="height" :direction="direction" v-if="currentPage=='p3'">
					<p3 @bgm="bgmHandle" />
				</page>
			</transition>
			<transition name="fade">
				<page :containerWidth="width" :containerHeight="height" :direction="direction"
					v-if="currentPage=='box'">
					<box @bgm="bgmHandle" />
				</page>
			</transition>

			<transition name="fade">
				<page :containerWidth="width" :containerHeight="height" :direction="direction"
					v-if="currentPage=='mine'">
					<mine @bgm="bgmHandle" />
				</page>
			</transition>
			<transition name="fade">
				<page :containerWidth="width" :containerHeight="height" :direction="direction"
					v-if="currentPage=='hb'">
					<hb @bgm="bgmHandle" />
				</page>
			</transition>

			<div class="bgm_controll" v-if="false" :class="{bgm_controll_an:bgmIsPlay}"
				@touchstart.stop.prevent="bgmHandle" @click="bgmHandle">
				<div class="full" style="z-index: 999;">
					<img class="on_icon" v-if="bgmIsPlay" src="../../_img/on_icon.png" />
					<img v-else src="../../_img/off_icon.png" />
				</div>
			</div>
			<rotateNotice v-if="rotate_notice" :direction="direction" />
		</div>
	</div>
</template>
<style>
	@font-face {
		font-family: 'time';
		src: url('./font/time.ttf');
	}

	.share_ele1 {
		position: absolute;
		width: 40%;
		top: 2%;
		right: 5%;
	}

	.HBIOS>img {
		pointer-events: auto;
		-webkit-touch-callout: default;
	}

	.HB>img {
		pointer-events: auto;
	}

	.input,
	.textarea {
		padding: 0;
		margin: 0;
		box-sizing: border-box;
		border: 0;
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-color: transparent;
	}

	.swiper-container,
	.swiper-slide {
		overflow: hidden;
	}

	.phone_container {
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	.fade-enter,
	.fade-leave-to {
		transform: translate3d(0, 0px, 0);
		opacity: 0;
	}

	.fade-leave,
	.fade-enter-to {
		transform: translate3d(0, 0, 0);
		opacity: 1;
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: all .5s
	}



	.dm1 {
		-webkit-animation: dm1 4s 0 linear infinite;
	}

	@-webkit-keyframes dm1 {
		0% {
			left: 100%;
		}

		100% {
			left: -100%;
		}
	}

	.bgm_controll {
		position: absolute;
		width: 30px;
		height: 30px;
		top: 2%;
		right: 2%;
	}

	.bgm_controll:hover {
		cursor: pointer;
	}

	.bgm_controll_an {
		-webkit-animation: bgm_controll_an 2s linear infinite;
	}

	@-webkit-keyframes bgm_controll_an {
		0% {
			-webkit-transform: rotate(0deg);
		}

		100% {
			-webkit-transform: rotate(360deg);
		}
	}

	.on_icon {
		-webkit-animation: on_icon 2s linear infinite;
	}

	@-webkit-keyframes on_icon {
		0% {
			-webkit-transform: rotate(0deg);
		}

		100% {
			-webkit-transform: rotate(360deg);
		}

	}

	.rotate {
		-webkit-animation: rotate 6s linear infinite;
	}

	@-webkit-keyframes rotate {
		0% {
			-webkit-transform: rotate(0deg);
		}

		100% {
			-webkit-transform: rotate(360deg);
		}

	}
</style>

<style scoped>

</style>


<script>
	import wx from 'weixin-js-sdk'
	import vueQr from 'vue-qr'
	import rotateNotice from '../../_components/rotateNotice.vue'
	import media from './components/media.vue'

	// import Swiper from 'swiper'
	// import 'swiper/swiper-bundle.css'
	export default {
		name: 'app',
		data() {
			return {
				pc: false,
				width: document.documentElement.clientWidth,
				height: document.documentElement.clientHeight,
				direction: 1,
				rotate_notice: false,
				orientationchange: false,
				bgm: true,
				qr: {
					url: window.location.href,
					//logo: require('../_../img/logo.png')
				},
				activeIndex: 0,
				p2Key: Math.random(),
				game1Key: Math.random(),
				game2Key: Math.random(),
				game3Key: Math.random()
			}
		},
		created() {
			let storeCode = this.$tool.getParam('storeCode', '')
			this.$store.commit('setShareInfo', {
				storeCode: storeCode
			})
			this.initSystem()
			this.init()
			if (process.env.NODE_ENV != 'development') {
				this.oauth().then(() => {
					this.$api.getInfo().then((res) => {
						if (this.$tool.isWeiXin()) {
							this.getJssdkConfig()
						}
						this.$store.commit('setUserInfo', res)
						this.$store.commit('setCurrentPage', {
							page: 'load'
						})
					})
				})
			} else {
				this.$api.getInfo().then((res) => {
					this.$store.commit('setUserInfo', res)
					this.$store.commit('setCurrentPage', {
						page: 'p1'
					})
				})
			}
		},
		mounted() {
			//this.$api.getRank()


		},
		computed: {
			currentPage() {
				return this.$store.state.currentPage
			},
			shareInfo() {
				return this.$store.state.shareInfo
			},
			userInfo() {
				return this.$store.state.userInfo
			},
			appShow() {
				return this.$store.state.appShow
			},
			bgmIsPlay() {
				return this.$store.state.bgmIsPlay
			}
		},
		methods: {
			init() {
				if (this.$tool.device() == 'pc') {
					this.pc = true
					this.width = document.documentElement.clientWidth
					this.height = document.documentElement.clientHeight
				} else {
					this.pc = false
					if (this.direction == 1 && (document.documentElement.clientWidth > document.documentElement
							.clientHeight)) {
						this.width = document.documentElement.clientWidth
						this.height = document.documentElement.clientHeight
						this.rotate_notice = true
						this.$store.commit('init', {
							app: this
						})
						return
					}
					if (this.direction == 0 && (document.documentElement.clientWidth < document.documentElement
							.clientHeight)) {
						this.width = document.documentElement.clientWidth
						this.height = document.documentElement.clientHeight
						this.rotate_notice = true
						this.$store.commit('init', {
							app: this
						})
						return
					}
					this.rotate_notice = false
					this.width = document.documentElement.clientWidth
					this.height = document.documentElement.clientHeight
				}

				this.$store.commit('init', {
					app: this
				})
			},
			initSystem() {
				window.addEventListener("resize", function() {
					if (!this.$tool.isWeiXin()) {
						this.init()
					}
				}.bind(this), false)

				window.addEventListener("orientationchange", function() {
					this.orientationchange = true
					setTimeout(function() {
						this.init()
					}.bind(this), 200)
				}.bind(this), false)
			},
			getJssdkConfig() {
				let that = this
				let url = encodeURIComponent(window.location.href)
				this.$api.getJssdk(url).then((res) => {
					wx.config(res)
					wx.ready(function() {
						wx.updateAppMessageShareData({
							title: window.config.shareTitle,
							desc: window.config.descContent,
							link: window.config.lineLink + '?storeCode=' + that.shareInfo
								.storeCode + '&id=' + that.userInfo.id,
							imgUrl: window.config.imgUrl,
							type: '',
							dataUrl: '',
							success: function() {

							},
							cancel: function() {

							}
						});
						wx.updateTimelineShareData({
							title: window.config.shareTitle,
							link: window.config.lineLink + '?storeCode=' + that.shareInfo
								.storeCode + '&id=' + that.userInfo.id,
							imgUrl: window.config.imgUrl,
							success: function() {

							},
							cancel: function() {}
						})
					})
				})

			},
			bgmHandle() {
				this.bgmIsPlay ? this.$store.commit('bgmPause') : this.$store.commit('bgmPlay')
			},
			oauth() {
				return new Promise((resolve) => {
					if (this.$tool.getParam('token')) {
						localStorage.setItem("token", this.$tool.getParam('token'))
					}
					resolve()
				})
			}
		},
		components: {
			vueQr,
			rotateNotice,
			media,

		}
	}
</script>
